import { Button, Grid, Spacer, Text, useMediaQuery } from '@geist-ui/react'
import { useNavigate } from 'react-router-dom'

import { ReactComponent as LogoSvg1 } from '../../assets/illustration-logo-1.svg'
import { ReactComponent as LogoSvg2 } from '../../assets/illustration-logo-2.svg'
import { ReactComponent as LogoSvg3 } from '../../assets/illustration-logo-3.svg'
import { ReactComponent as LogoSvg4 } from '../../assets/illustration-logo-4.svg'

import { ReactComponent as LogoSvg1BW } from '../../assets/illustration-logo-1-bw.svg'
import { ReactComponent as LogoSvg2BW } from '../../assets/illustration-logo-2-bw.svg'
import { ReactComponent as LogoSvg3BW } from '../../assets/illustration-logo-3-bw.svg'

import { ReactComponent as LogoSvgCV } from '../../assets/logo-cv.svg'
import { Project, projects } from '../projects'

export const Illustration = () => {
  const navigate = useNavigate()

  const isXs = useMediaQuery('xs')
  const isMdUp = useMediaQuery('md', { match: 'up' })

  const fontSize = isMdUp ? '50px' : '30px'

  // Map from project key to project id
  const map = (obj: Record<number, Project>) => Object.fromEntries(
    Object.entries(obj).map(([id, { key }]) => [key, id])
  )

  const projectsFromMQ = projects(isMdUp)
  const projectNameToIdIllustration = map(projectsFromMQ.illustration)
  const projectNameToGraphic = map(projectsFromMQ.graphic)

  return (
    <Grid.Container gap={0} justify='center'>
      {/* Title */}
      <Grid style={{ marginBottom: '20px' }} xs={24} justify='center'>
        <Text className='lato-light' font={fontSize}>ILLUSTRATION</Text>
      </Grid>

      {/* Icons */}
      {
        !isXs && (
          <Grid style={{ marginBottom: '50px' }} xs={24} justify='center'>
            <Grid.Container gap={1} justify='center'>
              <Grid xs={4}>
                <LogoSvg1 />
              </Grid>
              <Grid xs={4}>
                <LogoSvg2 />
              </Grid>
              <Grid xs={4}>
                <LogoSvg3 />
              </Grid>
              <Grid xs={4}>
                <LogoSvg4 />
              </Grid>
            </Grid.Container>
          </Grid>
        )
      }

      {/* Children's book section */}
      <Grid className='background-magenta' style={{ width: '100%', padding: '30px' }}>
        <Grid.Container gap={1} justify='center'>

          {/* Icon & Title */}
          <Grid xs={24} md={4} justify='center'>
            <Grid.Container justify='center'>
              <Grid xs={24} justify='center'>
                <LogoSvg1BW />
              </Grid>
              <Grid xs={24} justify='center'>
                <Text className='lato-light text-center' font='30px'>CHILDREN'S BOOK</Text>
              </Grid>
            </Grid.Container>
          </Grid>

          {/* Main content of the section */}
          <Grid xs={24} md={18} justify='center'>
            <Grid.Container gap={2} justify='space-around'>
              <Grid xs={24} justify='center'>
                <Text className='lato newline' font='16px'>
                  {`"La frase più bella che ricordo nella mia vita l'ha detta un bambino quando parlava di un disegno: "Che cos'è un disegno? è un'idea con intorno una linea" ... è bellissimo, questa è tutta la mia vita!"
                  - Bruno Bozzetto\n
                  Illustrare libri per bambi è sempre stato un mio sogno e sono felice di essere riuscita in parte a realizzarlo.
                  Di seguito una raccolta dei miei lavori migliori per gli Albi illustrati.`}
                </Text>
              </Grid>
              {/* Links to subsections */}
              <Grid xs={20} justify='center'>
                <Grid.Container gap={1} justify='center'>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToIdIllustration['matematicare']}`)}
                    >
                      <Text className='lato'>MatematicARE</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToIdIllustration['ora-guido-io']}`)}>
                      <Text className='lato'>Ora Guido IO!</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToIdIllustration['ecoconsigli']}`)}>
                      <Text className='lato'>ECOconsigli del Panda</Text>
                    </Button>
                  </Grid>
                </Grid.Container>
              </Grid>
            </Grid.Container>
          </Grid>

        </Grid.Container>
      </Grid>

      <Spacer h={2} />

      {/* Work on commission section */}
      <Grid className='background-yellow' style={{ width: '100%', padding: '30px' }}>
        <Grid.Container gap={1} justify='center'>

          {/* Icon & Title in mobile view */}
          {
            isXs && (

              < Grid xs={24} md={4} justify='center'>
                <Grid.Container justify='center'>
                  <Grid xs={24} justify='center'>
                    <LogoSvg2BW />
                  </Grid>
                  <Grid xs={24} justify='center'>
                    <Text className='lato-light text-center' font='30px'>WORK ON COMMISSION</Text>
                  </Grid>
                </Grid.Container>
              </Grid>
            )
          }

          {/* Main content of the section */}
          <Grid xs={24} md={18} justify='center'>
            <Grid.Container gap={2} justify='space-around'>
              <Grid xs={24} justify='center'>
                <Text className='lato' font='16px'>
                  Le illustrazioni su commissione partono dall'idea di realizzazre un'illustrazione per un progetto occasionale: per arricchire i muri del tuo ufficio, per festeggire un avvenimento importante, da regalare ai vincitori di un contest o per curare l'immagine di piccole realtà.
                  Non c'è limite alla creatività e all'illustrazione.
                  Di seguito una raccolta dei miei migliori Work on Commission.
                </Text>
              </Grid>
              {/* Links to subsections */}
              <Grid xs={20} justify='center'>
                <Grid.Container gap={1} justify='center'>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToIdIllustration['carbonara']}`)}>
                      <Text className='lato'>“Carbonara Stories”</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToIdIllustration['luogocomune']}`)}>
                      <Text className='lato'>LUOGOCOMUNE</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`./${projectNameToIdIllustration['collettivo']}`)}>
                      <Text className='lato'>“Senz'API finisce la favola”</Text>
                    </Button>
                  </Grid>
                </Grid.Container>
              </Grid>
            </Grid.Container>
          </Grid>

          {/* Icon & Title in desktop view */}
          {
            !isXs && (
              <Grid xs={24} md={4} justify='center'>
                <Grid.Container justify='center'>
                  <Grid xs={24} justify='center'>
                    <LogoSvg2BW />
                  </Grid>
                  <Grid xs={24} justify='center'>
                    <Text className='lato-light text-center' font='30px'>WORK ON COMMISSION</Text>
                  </Grid>
                </Grid.Container>
              </Grid>
            )
          }

        </Grid.Container>
      </Grid >

      <Spacer h={2} />

      {/* Marketing illustration section */}
      <Grid className='background-cyan' style={{ width: '100%', padding: '30px' }}>
        <Grid.Container gap={1} justify='center'>

          {/* Icon & Title */}
          <Grid xs={24} md={4} justify='center'>
            <Grid.Container justify='center'>
              <Grid xs={24} justify='center'>
                <LogoSvg3BW />
              </Grid>
              <Grid xs={24} justify='center'>
                <Text className='lato-light text-center' font='30px'>MARKETING ILLUSTRATION</Text>
              </Grid>
            </Grid.Container>
          </Grid>

          {/* Main content of the section */}
          <Grid xs={24} md={18} justify='center'>
            <Grid.Container gap={2} justify='space-around'>
              <Grid xs={24} justify='center'>
                <Text className='lato' font='16px'>
                  Il Marketing illustration è la produzione  personalizzata di illustrazioni per l'azienda con lo scopo di  realizzare progetti grafici per prodotti su misura.
                  Le illustrazioni rispecchiano in stile e colori l'identità aziendale e possono essere utilizzate per creare icone personalizzate, mascotte aziendali, merchandising per compagne  pubblicitarie, packaging e linee di prodotto specifiche.
                  Di seguito una raccolta dei miei migliori lavori di Marketing illustration.
                </Text>
              </Grid>
              {/* Links to subsections */}
              <Grid xs={20} justify='center'>
                <Grid.Container gap={1} justify='center'>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`../graphic/${projectNameToGraphic['ecoeridania']}`)}>
                      <Text className='lato'>Ecoeridania</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`../graphic/${projectNameToGraphic['terrazza-bonsai']}`)}>
                      <Text className='lato'>Terrazza Bonsai</Text>
                    </Button>
                  </Grid>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate(`../graphic/${projectNameToGraphic['falconeri-sanremo']}`)}>
                      <Text className='lato'>Falconeri per SANREMO</Text>
                    </Button>
                  </Grid>
                </Grid.Container>
              </Grid>
            </Grid.Container>
          </Grid>

        </Grid.Container>
      </Grid>

      <Spacer h={2} />

      {/* CV section */}
      <Grid style={{ width: '100%', backgroundColor: 'White', padding: '30px' }}>
        <Grid.Container gap={1} justify='center'>

          {/* Icon & Title in mobile view */}
          {
            isXs && (
              <Grid xs={24} md={4} justify='center'>
                <Grid.Container justify='center'>
                  <Grid xs={24} justify='center'>
                    <LogoSvgCV />
                  </Grid>
                  <Grid xs={24} justify='center'>
                    <Text className='lato-light text-center' font='30px'>CURRICULUM VITAE</Text>
                  </Grid>
                </Grid.Container>
              </Grid>
            )
          }

          {/* Main content of the section */}
          <Grid xs={24} md={18} justify='center'>
            <Grid.Container gap={2} justify='space-around'>
              <Grid xs={24} justify='center'>
                <Text className='lato' font='16px'>
                  Mi chiamo Nora Gallia e lavoro nel campo della comunicazione e della  grafica. Il mio lavoro come libero professionista mi ha resa capace di gestire contemporaneamente e in completa autonomia  diversi tipi di progetto, sempre rispettando le dead line concordate con il cliente.
                  Mi piace il mio lavoro e seguo i progetti  con precisione e passione. Il mio parco clienti è estremamente eterogeneo, questo mi ha portato ad essere sensibile e attenta ad ogni genere di richiesta, riuscendomi ad  allineare già dal primo brief con le richieste del cliente. Sono determinata e motivata ad imparare cose nuove e a crescere lavorativamente.
                </Text>
              </Grid>
              {/* Links to subsections */}
              <Grid xs={20} justify='center'>
                <Grid.Container gap={1} justify='center'>
                  <Grid xs={24} md={8} justify='center'>
                    <Button
                      style={{ width: '100%', borderRadius: '25px', border: '1px solid black', background: 'transparent' }}
                      onClick={() => navigate('../cv')}
                    >
                      <Text className='lato'>Curriculum Vitae</Text>
                    </Button>
                  </Grid>
                </Grid.Container>
              </Grid>
            </Grid.Container>
          </Grid>

          {/* Icon & Title in desktop view */}
          {
            !isXs && (
              <Grid xs={24} md={4} justify='center'>
                <Grid.Container justify='center'>
                  <Grid xs={24} justify='center'>
                    <LogoSvgCV />
                  </Grid>
                  <Grid xs={24} justify='center'>
                    <Text className='lato-light text-center' font='30px'>CURRICULUM VITAE</Text>
                  </Grid>
                </Grid.Container>
              </Grid>
            )
          }

        </Grid.Container>
      </Grid>

      <Spacer h={6} />

    </Grid.Container >
  )
}
